"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hookConfig = void 0;
var _constants = require("../constants");
var hookConfig = exports.hookConfig = {
  appKey: _constants.APP_NAMESPACE,
  defaultRecordOwnerEmail: _constants.DEFAULT_RECORD_OWNER_EMAIL
};